module.exports = __webpack_public_path__ + "static/media/28331383-preview.b5f84d33.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/28331383-preview.mp4
// module id = 1816
// module chunks = 0